import React from 'react';
import { PricingConfigurator } from '../../components/PricingConfigurator';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { toast } from 'sonner';

export const PortalTarif = () => {
  const handleSaveChanges = () => {
    toast.success('Alles klar – wir setzen das für dich um.');
  };

  return (
    <div className="space-y-8" data-testid="portal-tarif">
      <div>
        <h1 className="font-display text-3xl font-semibold">Passe deine Wolke an</h1>
        <p className="mt-2 text-muted-foreground">
          Änderungen sind schnell erledigt. Du siehst den Preis live.
        </p>
      </div>

      <PricingConfigurator />

      <Card className="glass-card border-primary/20">
        <CardHeader>
          <CardTitle>Hinweis</CardTitle>
          <CardDescription>
            Änderungen gelten ab sofort. Deine nächste Rechnung wird entsprechend angepasst.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button onClick={handleSaveChanges} className="w-full md:w-auto">
            Änderungen speichern
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
